import React from "react";
import styled from "@emotion/styled";
import { baseWidths, colors, footer, header } from "src/theme";
import { mediaQuery } from "src/common";

const ContentStyle = styled.div({
  position: 'relative',
  paddingTop: `${header.mobileHeight}px`,
  backgroundColor: colors.background6,
  minHeight: `calc(100vh - ${footer.mobileHeight}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height}px)`,
  },

  [mediaQuery('laptopL')]: {
    paddingTop: `${header.height}px`,
  },
})

const ContainerStyle = styled.div({
  width: '88%',
  margin: '0 auto',
  paddingBlock: '40px',

  [mediaQuery('mobile')]: {
    width: `${baseWidths.mobile}px`
  },

  // [mediaQuery('laptopL')]: {
  //   paddingBlock: '40px'
  // },
})

interface ContentProps {
  children: React.JSX.Element | React.JSX.Element[];
}

export const Content = ({ children }: ContentProps) =>
  <ContentStyle>
    <ContainerStyle>
      {children}
    </ContainerStyle>
  </ContentStyle>;
